
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { UnitSystem } from '@/utils/unitConversion/types';
import UnitToggle from '@/components/UnitToggle';

interface FamilySizeSettingsProps {
  adults: number;
  kids: number;
  preferredUnits: UnitSystem;
  onAdultsChange: (value: number) => void;
  onKidsChange: (value: number) => void;
  onUnitChange: (value: UnitSystem) => void;
}

const FamilySizeSettings: React.FC<FamilySizeSettingsProps> = ({
  adults,
  kids,
  preferredUnits,
  onAdultsChange,
  onKidsChange,
  onUnitChange,
}) => {
  return (
    <div className="space-y-4">
      <Label className="text-sm font-medium">Family & Units</Label>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Family Settings - Left Column */}
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="adults">Adults</Label>
              <Input
                id="adults"
                type="number"
                min="0"
                max="20"
                value={adults}
                onChange={(e) => onAdultsChange(Math.max(0, parseInt(e.target.value) || 0))}
                className="w-full"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="kids">Kids</Label>
              <Input
                id="kids"
                type="number"
                min="0"
                max="20"
                value={kids}
                onChange={(e) => onKidsChange(Math.max(0, parseInt(e.target.value) || 0))}
                className="w-full"
              />
            </div>
          </div>
        </div>

        {/* Units Settings - Right Column */}
        <div className="space-y-2">
          <Label className="text-sm">Units</Label>
          <div className="flex justify-start">
            <UnitToggle value={preferredUnits} onValueChange={onUnitChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilySizeSettings;
